import React from "react";
import styled, { css } from "styled-components";
import Loading from "../Loading";

class Languages extends React.Component {
    state = {
        generalData: null,
        loading: false
    }

    componentDidMount() {
        const { country } = this.props;
        this.setState({ loading: true });

        if (this.props.country) {
            import(`../../data/reports/${ country }-report.json`)
                .then(data => {
                    this.setState({
                        generalData: data.default,
                        loading: false
                    })
                })
        }
    }

    render() {
        return <Container>
            <Title>Most used languages</Title>
            <Loading isDisplayed={ this.state.loading } />
            <LanguagesWrapper>
                { this.state.generalData
                    ? Object.entries(this.state.generalData.totalLanguages).map(([ langName, percentage ], index) => {
                        return <LangWrapper key={ langName } mode={ this.props.mode }>
                            {/* <ProgressBar /> */}
                            <p>{ index + 1}. { langName }</p>
                            <p>{ percentage.toFixed(2) }%</p>
                        </LangWrapper>
                    })
                    : null }
            </LanguagesWrapper>
        </Container>
    }
}

const Container = styled.div`
`

const Title = styled.h2`
    font-size: 24px;
    margin: 8px 0;
`

const LangWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    margin-bottom: 12px;
    position: relative;
    font-weight: bold;
    background: #e2e2e2;
    padding: 12px;
    border-radius: 5px;

    ${ props => props.mode === "dark" && css`
        background: #353535;
    ` }

    p {
        z-index: 100;
    }
`

const ProgressBar = styled.div`
    /* position: absolute;
    height: 20px;
    background: #ffc5c5;
    width: 100%; */
`

const LanguagesWrapper = styled.div`
    font-size: 14px;
    overflow: auto;
    padding: 0 12px 0 0;
    height: calc(100vh - 220px);

    &::-webkit-scrollbar-thumb {
        background: #565656;
        border-radius: 10px;
    }

    &::-webkit-scrollbar {
        background: #40404075;
        width: 8px;
        border-radius: 10px;
    }
`

export default Languages;